var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrange(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_624_3052)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.75 11.375C1.75 6.05967 6.05908 1.75 11.3744 1.75C16.6903 1.75 20.9994 6.05908 20.9994 11.375C20.9994 16.6909 16.6903 21 11.3744 21C6.05908 21 1.75 16.6909 1.75 11.375Z",
    fill: "#F4900C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.65808 4.42445C6.50233 4.2687 6.19316 4.30953 5.86766 4.49445C3.94266 2.90078 0.820078 2.36412 0.678912 2.34078C0.360412 2.28887 0.0611616 2.50237 0.00807826 2.8197C-0.0450051 3.13703 0.169078 3.43803 0.486995 3.49112C0.517912 3.49637 3.36516 3.98928 5.04924 5.33445C4.88883 5.6407 4.86024 5.92653 5.00841 6.07412C5.23591 6.3022 5.79008 6.11728 6.24566 5.6617C6.70124 5.2067 6.88558 4.65253 6.65808 4.42445V4.42445Z",
    fill: "#662113"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2499 0.583087C12.2499 0.583087 10.4381 3.10192 8.15434 3.659C6.41659 4.08309 4.10717 4.12392 3.87676 3.58725C3.64692 3.05117 4.79376 1.29067 6.77534 0.441337C8.75692 -0.407413 12.2499 0.583087 12.2499 0.583087Z",
    fill: "#5C913B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_624_3052"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrange);
export default __webpack_public_path__ + "static/media/orange.c8f5935efeadbc0714c31755f08ddcb0.svg";
export { ForwardRef as ReactComponent };